import dayjs from 'dayjs';

const layoverDays = (dates) => {
  const arrival = dayjs(dates.arrival);
  const departure = dayjs(dates.departure);
  const diffDays = arrival.diff(departure, 'day');
  return diffDays > 0 ? `+${diffDays}` : '';
};

const isOvernightLayover = (dates) => {
  const arrival = dayjs(dates.arrival);
  const departure = dayjs(dates.departure);
  const diffDays = departure.diff(arrival, 'day');
  return diffDays > 0;
};

const isOvernightFlight = (dates) => {
  const arrival = dayjs(dates.arrival);
  const departure = dayjs(dates.departure);
  const diffDays = arrival.diff(departure, 'day');
  return diffDays > 0;
};

export default { layoverDays, isOvernightLayover, isOvernightFlight };
